import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import { assertResponseSuccess, generateRequestID, getSwicusWebAppUrl } from '../utils/api';
export var putUserAttribute = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment, key, value) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(getSwicusWebAppUrl(environment), "/v1/user-attributes"), {
              headers: {
                'content-type': 'application/json',
                'x-request-id': generateRequestID()
              },
              method: 'PUT',
              credentials: 'include',
              body: _JSON$stringify({
                key: key,
                value: value
              })
            });

          case 2:
            result = _context.sent;
            assertResponseSuccess(result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function putUserAttribute(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();